import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupPassword = () => {
  const { t } = useTranslation();
  return {
    // current_password: Yup.string().required(
    //   t("validation.required", {
    //     current_password: t("page.current_password"),
    //   })
    // ),
    new_password: Yup.string()
      .required(
        t("validation.required", {
          new_password: t("page.new_password"),
        })
      )
      .min(6, "Too Short!"),
  };
};
